import { render, staticRenderFns } from "./StatsTeamStats.vue?vue&type=template&id=45bbce5d&"
import script from "./StatsTeamStats.vue?vue&type=script&lang=js&"
export * from "./StatsTeamStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports